import texts from './welcome.texts'

class WelcomeController {
    constructor($state, $timeout) {
        this.name = 'Welcome'

        this.$state = $state
        this.$timeout = $timeout
    }

    $onInit() {
        // Set active language on page load
        this.language = localStorage.getItem('tourists_lang') || 'EN'

        this.render()

        // Track welcome video events
        const welcomeVideo = document.getElementById('welcomeVideo')

        this.setVideoDuration(welcomeVideo)

        welcomeVideo.ontimeupdate = this.timeupdate
        welcomeVideo.onended = this.videoEnded.bind(this)

        localStorage.setItem('tourists_welcome', true)
    }

    render() {
        const {
            SKIP,
            SKIP_DESCRIPTION
        } = texts[this.language]

        this.skip = SKIP
        this.skipDescription = SKIP_DESCRIPTION
    }

    setVideoDuration(video) {
        const that = this

        const videoInterval = setInterval(() => {
            if (video.readyState > 0) {
                that.videoDuration = video.duration % 60
                clearInterval(videoInterval)
            }
        }, 200)
    }

    timeupdate() {
        const width = (this.currentTime / this.duration) * 100
        const videoLine = document.getElementById('videoLine')

        if (videoLine) {
            videoLine.style.width = width + '%'
        }
    }

    videoEnded() {
        this.$timeout(() => {
            this.$state.go('home')
        }, 800)
    }

    changeLanguage(language) {
        this.language = language

        localStorage.setItem('tourists_lang', language)

        this.render()
    }
}

WelcomeController.$inject = ['$state', '$timeout']

export default WelcomeController



// WEBPACK FOOTER //
// ./client/app/components/welcome/welcome.controller.js